export enum CategoriePdP {
	EOL = "EOL",
	PV = "PV",
	MIXTE = "MIXTE"
}

export class TraductionPdp {
	id!: number;
	parent!: TraductionPdp;
	type!: string;
	traductionKey!: string;
	fr!: string;
	en!: string;
	es!: string;
	ordre!: number;
	children!: TraductionPdp[];
	activites!: TraductionPdp[];
	riskOrImpacts!: TraductionPdp[];
	mesures!: TraductionPdp[];
	selected: boolean = false;
	chargeEntrepriseExterne: boolean = false;
	chargeEntrepriseUtilisatrice: boolean = false;
	responsibility!: string;
	autre!: string;
	poidsFemme!: number;
	poidsHomme!: number;
	updatable: boolean = true;
	categoriePdp!: CategoriePdP;
	
	constructor() {}
}